import { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './Settings.module.css';

const API_BASE = '/api/admin';

const Settings = () => {
  const [settings, setSettings] = useState({
    trade_fee_markup: '',
    management_fee: '',
    conversion_fee: '',
    direct_bonus: '',
  });
  
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const token = localStorage.getItem('adminAccessToken');
        const res = await axios.get(`${API_BASE}/settings/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setSettings(res.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching settings:', err);
        setError('Failed to load settings / settings is empty.');
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      const token = localStorage.getItem('adminAccessToken');
      await axios.put(`${API_BASE}/settings/update/`, settings, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setSuccess('Settings updated successfully.');
      setError('');
    } catch (err) {
      console.error('Error updating settings:', err);
      setError('Failed to update settings.');
      setSuccess('');
    } finally {
      setSaving(false);
    }
  };
  if (loading) return <div className={styles.loading}>Loading...</div>;
  return (
    <div className={styles.pageContainer}>
      <h1>Settings</h1>

      {error && <div className={styles.error}>{error}</div>}
      {success && <div className={styles.success}>{success}</div>}

      <div className={styles.formGroup}>
        <label>Trade Fee Markup (%)</label>
        <input
          type="number"
          name="trade_fee_markup"
          value={settings.trade_fee_markup}
          onChange={handleChange}
          className={styles.input}
        />
      </div>
      <div className={styles.formGroup}>
        <label>Management Fee (%)</label>
        <input
          type="number"
          name="management_fee"
          value={settings.management_fee}
          onChange={handleChange}
          className={styles.input}
        />
      </div>
      <div className={styles.formGroup}>
        <label>Conversion Fee (%)</label>
        <input
          type="number"
          name="conversion_fee"
          value={settings.conversion_fee}
          onChange={handleChange}
          className={styles.input}
        />
      </div>
      <div className={styles.formGroup}>
        <label>Direct Bonus (%)</label>
        <input
          type="number"
          name="direct_bonus"
          value={settings.direct_bonus}
          onChange={handleChange}
          className={styles.input}
        />
      </div>
      <button onClick={handleSave} disabled={saving} className={styles.saveButton}>
        {saving ? 'Saving...' : 'Save Settings'}
      </button>
    </div>
  );
};

export default Settings;
